<template>
    <div>
        <!-- SALES AUDIT & EIS SYNC -->
        <v-dialog
            v-model="dialog_sync"
            scrollable
            :persistent="true" :overlay="false"
            max-width="900px"
            transition="dialog-transition" >
            <v-card rounded="lg" v-if="dialog_sync">
                <v-card-title class="primary">
                    <div class="font-weight-bold b2--text">
                        <v-icon dark large>mdi-cloud-sync-outline</v-icon>
                        SALES AUDIT & EIS SYNC
                    </div>
                    <v-spacer></v-spacer>
                    <v-btn class="mr-2" rounded color="secondary" @click="ON_SELECT_DAYSHIFTS()"><v-icon class="mr-2">mdi-calendar-expand-horizontal</v-icon> Day shifts</v-btn>
                    <v-btn dark icon :disabled="syncing" @click="CLOSE()"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>

                <v-card flat class="mbs-scroll-y">
                    <v-stepper v-model="step" vertical>

                        <!-- //----------------[STEP1]------------------>
                        <v-stepper-step :complete="step > 1" step="1">
                            Select day shifts
                            <small>{{ selected_keys.length }} of {{ Shifts.length }} selected</small>
                        </v-stepper-step>
                        <v-stepper-content step="1">
                            <v-card outlined class="mb-2">
                                <v-layout class="ma-0 px-3 py-1" align-center>
                                    <span class="font-weight-bold">Day shifts</span>
                                    <v-spacer></v-spacer>
                                    <v-btn small text @click="ON_SELECT_ALL()">
                                        {{ AllSelected ? 'Clear selection' : 'Select all' }}
                                    </v-btn>
                                </v-layout>
                                <v-divider></v-divider>
                                <v-list dense class="mbs-scroll-y" :max-height="Math.max(vsh-450,250)">
                                    <template v-for="shift in Shifts">
                                        <v-list-item :key="shift.key" @click="TOGGLE_SHIFT(shift.key)">
                                            <v-list-item-action>
                                                <v-icon :color="IsSelected(shift.key)?'primary':''">
                                                    {{ IsSelected(shift.key) ? 'mdi-checkbox-marked-outline' : 'mdi-checkbox-blank-outline' }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ ShiftTitle(shift) }}</v-list-item-title>
                                                <v-list-item-subtitle>Key: {{ shift.key }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action v-if="shift.eis_reconciled">
                                                <v-chip small outlined>Reconciled</v-chip>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="'d1'+shift.key"></v-divider>
                                    </template>
                                    <v-layout v-if="!Shifts.length" justify-center class="pa-5">
                                        <v-chip large class="px-5">
                                            <v-icon>warning</v-icon>
                                            <div class="ml-2 grey--text">No day shifts</div>
                                        </v-chip>
                                    </v-layout>
                                </v-list>
                            </v-card>
                            <v-btn color="primary" :disabled="!selected_keys.length" @click="CONFIRM_SYNC(selected_keys)">
                                Start sync
                            </v-btn>
                            <v-btn text @click="CLOSE()">Cancel</v-btn>
                        </v-stepper-content>

                        <!-- //----------------[STEP2]------------------>
                        <v-stepper-step :complete="step > 2" step="2">
                            Syncing with EIS
                            <small v-if="run_keys.length">{{ ProcessedCount }} / {{ run_keys.length }} processed</small>
                        </v-stepper-step>
                        <v-stepper-content step="2">
                            <v-progress-linear
                                :value="Progress" height="10" stream
                                color="secondary" class="mb-2">
                            </v-progress-linear>
                            <div v-if="current_key" class="mb-2 font-weight-bold">
                                Submitting: {{ ShiftTitle(FindShift(current_key)) }}
                            </div>
                            <v-card outlined class="mb-2">
                                <v-list dense class="mbs-scroll-y" :max-height="Math.max(vsh-500,250)">
                                    <template v-for="shift in RunShifts">
                                        <v-list-item :key="shift.key">
                                            <v-list-item-avatar>
                                                <v-progress-circular v-if="StatusOf(shift.key)=='submitting'"
                                                    indeterminate size="24" width="3" color="secondary">
                                                </v-progress-circular>
                                                <v-icon v-else :color="StatusMeta(shift.key).color">{{ StatusMeta(shift.key).icon }}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ ShiftTitle(shift) }}</v-list-item-title>
                                                <v-list-item-subtitle v-if="ShiftFiscalized(shift.key)" class="font-weight-bold">{{ ShiftFiscalized(shift.key) }}</v-list-item-subtitle>
                                                <v-list-item-subtitle>{{ ShiftSummary(shift.key) }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-chip small outlined :color="StatusMeta(shift.key).color">{{ StatusMeta(shift.key).text }}</v-chip>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="'d2'+shift.key"></v-divider>
                                    </template>
                                </v-list>
                            </v-card>
                            <v-btn color="error" :disabled="stop_requested" @click="stop_requested=true">
                                {{ stop_requested ? 'Stopping after current...' : 'Stop' }}
                            </v-btn>
                        </v-stepper-content>

                        <!-- //----------------[STEP3]------------------>
                        <v-stepper-step step="3" :complete="step == 3 && !RetryKeys.length">
                            Results
                            <small v-if="step == 3">
                                {{ RetryKeys.length ? RetryKeys.length + ' need attention' : 'All synced' }}
                            </small>
                        </v-stepper-step>
                        <v-stepper-content step="3">
                            <v-card outlined class="pa-3 mb-2">
                                <v-layout row wrap class="ma-0">
                                    <v-chip small class="mr-1 mb-1">Transactions: {{ Totals.orders }}</v-chip>
                                    <v-chip small class="mr-1 mb-1" color="success">Total fiscalized: {{ Totals.fiscalized }}</v-chip>
                                    <v-chip small class="mr-1 mb-1" color="success" outlined>Newly uploaded: {{ Totals.uploaded }}</v-chip>
                                    <v-chip small class="mr-1 mb-1" outlined>Already fiscalized: {{ Totals.already }}</v-chip>
                                    <v-chip small class="mr-1 mb-1" :color="Totals.failed?'error':''" :outlined="!Totals.failed">Failed: {{ Totals.failed }}</v-chip>
                                    <v-chip small class="mr-1 mb-1" outlined>Cancelled: {{ Totals.cancelled }}</v-chip>
                                </v-layout>
                            </v-card>

                            <v-alert v-if="!RetryKeys.length" type="success" text dense>
                                All selected day shifts are synced with EIS.
                            </v-alert>

                            <v-card v-else outlined class="mb-2">
                                <v-list dense class="mbs-scroll-y" :max-height="Math.max(vsh-550,250)">
                                    <template v-for="shift in RetryShifts">
                                        <v-list-item :key="shift.key" @click="TOGGLE_DETAILS(shift.key)">
                                            <v-list-item-avatar>
                                                <v-icon :color="StatusMeta(shift.key).color">{{ StatusMeta(shift.key).icon }}</v-icon>
                                            </v-list-item-avatar>
                                            <v-list-item-content>
                                                <v-list-item-title>{{ ShiftTitle(shift) }}</v-list-item-title>
                                                <v-list-item-subtitle v-if="ShiftFiscalized(shift.key)" class="font-weight-bold">{{ ShiftFiscalized(shift.key) }}</v-list-item-subtitle>
                                                <v-list-item-subtitle>{{ ShiftSummary(shift.key) }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <v-btn small outlined color="primary" @click.stop="VIEW_SHIFT(shift,true)">
                                                    <v-icon small class="mr-1">mdi-eye</v-icon> View Shift
                                                </v-btn>
                                                 <v-btn small outlined color="primary" @click.stop="CONFIRM_SYNC([shift.key],true)">
                                                    <v-icon small class="mr-1">mdi-refresh</v-icon> Resubmit
                                                </v-btn>
                                            </v-list-item-action>
                                            <v-list-item-action>
                                                <v-icon>{{ expanded_key == shift.key ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                                            </v-list-item-action>
                                        </v-list-item>
                                        <div v-if="expanded_key == shift.key" :key="'x'+shift.key" class="px-4 pb-3 grey lighten-4">
                                            <div v-if="results[shift.key] && results[shift.key].message" class="pt-2 error--text">
                                                {{ results[shift.key].message }}
                                            </div>
                                            <div v-for="(f,i) in FailedOrders(shift.key)" :key="i" class="pt-2 not-f2">
                                                <b>{{ i+1 }}. {{ f.invoice_number || f.key }}</b>
                                                <span v-if="f.till_code"> | Till {{ f.till_code }}</span>
                                                <span v-if="f.total_price"> | {{ f.total_price }}</span>
                                                <div class="error--text">{{ f.message }}</div>
                                            </div>
                                        </div>
                                        <v-divider :key="'d3'+shift.key"></v-divider>
                                    </template>
                                </v-list>
                            </v-card>

                            <v-btn v-if="RetryKeys.length" color="primary" @click="CONFIRM_SYNC(RetryKeys,true)">
                                Resubmit all ({{ RetryKeys.length }})
                            </v-btn>
                            <v-btn @click="step = 1">Back</v-btn>
                            <v-btn text @click="CLOSE()">Close</v-btn>
                        </v-stepper-content>

                    </v-stepper>
                </v-card>
            </v-card>
        </v-dialog>
        <div>
             <!-- // DAYSHIFTS -->
            <mbs-dayshift-selector  
                v-model="filter_date"
                :dialog="true"
                color="text--darken-2 white"
                title_color="secondary"
                :max_from_date="MBS.date.moment().format('yyyy-MM-DD')" 
                :max_to_date="MBS.date.moment().format('yyyy-MM-DD')"
                :default_days="'30'" 
                @apply="APPLY_DAYSHIFTS"
                /> 
            <mbs-day-shift-sales-report
                v-model="dialog_shift_sales_report"
                :day_shift="selected_day_shift"
                /> 
        </div>
    </div>
</template>
<script>
    import DATA from "../../../plugins/DATA";
    import {mapState} from "vuex";
    import { toNumber } from "../../../plugins/formatNumber";
    const PAGE_NAME = "SALES_AUDIT_SYNC";

    export default {
        props:['dayshifts'],
        data(){
            return{
                dialog_sync:false,
                step:1,
                syncing:false,
                dialog_shift_sales_report:false,
                selected_day_shift:null,
                stop_requested:false,
                payload_dayshifts:null,
                selected_keys:[],
                queue_keys:[],      // every dayshift in this session (used for totals / retry list)
                run_keys:[],        // dayshifts in the current run (used for step 2)
                current_key:null,
                results:{},         // {[dayshift.key]: {status, summary, message}}
                expanded_key:null,
                filter_date:null,
                DayShifts:null,
                DATA,
                VALUE_ITEM:DATA.ITEMS.ITEMS.value,
            }
        },
        created(){
            try {
                this.MBS.events.$on('DIALOG_YES', this.DIALOG_YES);
                this.MBS.events.$on('SALES_AUDIT_SYNC', this.OPEN_SALES_AUDIT_SYNC);
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'created',
                    page:PAGE_NAME,
                })
            }
        },
        computed:{
            vsh(){
                return this.$vuetify.breakpoint.height
            },
            ...mapState({
                us: state=> state.users[(DATA.ITEMS.USERS.value).toUpperCase()],
                SELECTED_COMPANY: state=> state.items['SELECTED_COMPANY'],
            }),
            Shifts(){
                const list = this.payload_dayshifts || this.dayshifts
                return list ? [...list] : []
            },
            FindShift(){
                const shifts = this.Shifts
                return key=>shifts.find(item=>item.key == key)
            },
            AllSelected(){
                return this.Shifts.length>0 && this.selected_keys.length == this.Shifts.length
            },
            StatusOf(){
                return key=>this.results[key]?.status || 'pending'
            },
            StatusMeta(){
                const meta = {
                    pending:{icon:'mdi-clock-outline',color:'grey',text:'Waiting'},
                    submitting:{icon:'mdi-cloud-upload-outline',color:'secondary',text:'Submitting'},
                    success:{icon:'mdi-check-circle',color:'success',text:'Synced'},
                    already:{icon:'mdi-check-all',color:'grey',text:'Already synched'},
                    partial:{icon:'mdi-alert-circle',color:'error',text:'Has failures'},
                    error:{icon:'mdi-close-circle',color:'error',text:'Request failed'},
                }
                return key=>meta[this.StatusOf(key)]
            },
            RunShifts(){
                return this.run_keys.map(key=>this.FindShift(key)).filter(item=>item)
            },
            ProcessedCount(){
                return this.run_keys.filter(key=>{
                    const status = this.StatusOf(key)
                    return status!='pending' && status!='submitting'
                }).length
            },
            Progress(){
                const total = this.run_keys.length
                return total ? this.ProcessedCount*100/total : 0
            },
            // failed (has eis_upload_fail / request error) or not processed because sync was stopped
            RetryKeys(){
                return this.queue_keys.filter(key=>['partial','error','pending'].includes(this.StatusOf(key)))
            },
            RetryShifts(){
                return this.RetryKeys.map(key=>this.FindShift(key)).filter(item=>item)
            },
            Totals(){
                const totals = {orders:0,fiscalized:0,uploaded:0,already:0,failed:0,cancelled:0}
                this.queue_keys.forEach(key=>{
                    const summary = this.results[key]?.summary
                    if (!summary) {return}
                    totals.orders += summary.orders
                    totals.fiscalized += summary.fiscalized
                    totals.uploaded += summary.uploaded
                    totals.already += summary.already
                    totals.failed += summary.failed
                    totals.cancelled += summary.cancelled
                })
                return totals
            },
        },
        methods:{
            //---------------[OPEN / CLOSE]------------
            OPEN_SALES_AUDIT_SYNC(payload){
                try {
                    this.payload_dayshifts = payload?.dayshifts || null
                    this.results = {}
                    this.queue_keys = []
                    this.run_keys = []
                    this.expanded_key = null
                    this.selected_keys = this.Shifts.filter(item=>!item.eis_reconciled).map(item=>item.key)
                    this.step = 1
                    this.dialog_sync = true
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'OPEN_SALES_AUDIT_SYNC',
                        page:PAGE_NAME,
                    })
                }
            },
            ON_SELECT_DAYSHIFTS(){
                this.MBS.events.$emit("ON_DAYSHIFT_SELECTOR")
            },
            CLOSE(){
                Object.assign(this.$data, this.$options.data())
            },
            APPLY_DAYSHIFTS(data){
                try {
                    console.log(data,'APPLY_DAYSHIFTS........');
                    // this.CONFIRM_AUDITING_AGGREGATE_SALE(data.selected_dayshifts)
                    this.DayShifts = data.selected_dayshifts
                    this.MBS.events.$emit("SALES_AUDIT_SYNC",{dayshifts:data.selected_dayshifts})  
                    // this.CONFIRM_SYNCH_WITH_EIS(data.selected_dayshifts)
                     
                } catch (error) {
                    
                }

            },

            //---------------[SELECTION]------------
            IsSelected(key){
                return this.selected_keys.includes(key)
            },
            TOGGLE_SHIFT(key){
                if (this.IsSelected(key)) {
                    this.selected_keys = this.selected_keys.filter(k=>k != key)
                } else {
                    this.selected_keys = [...this.selected_keys, key]
                }
            },
            ON_SELECT_ALL(){
                this.selected_keys = this.AllSelected ? [] : this.Shifts.map(item=>item.key)
            },
            TOGGLE_DETAILS(key){
                this.expanded_key = this.expanded_key == key ? null : key
            },

            //---------------[DISPLAY HELPERS]------------
            // swap for your own dayshift label field if there is one
            ShiftTitle(shift){
                if (!shift) {return ''}
                if (shift.outlet_name) {return shift.outlet_name+" | "+shift.operating_date_}
                try {
                    return this.MBS.date.convert(shift.key) || String(shift.key)
                } catch (error) {
                    return String(shift.key)
                }
            },
            ShiftSummary(key){
                const result = this.results[key]
                if (!result) {return 'Waiting'}
                if (result.status == 'already') {return 'Already reconciled'}
                if (result.status == 'error') {return result.message}
                const s = result.summary
                if (!s) {return result.status == 'submitting' ? 'Submitting...' : 'Waiting'}
                return `Transactions ${s.orders} | New ${s.uploaded} | Already ${s.already} | Failed ${s.failed} | Cancelled ${s.cancelled}`
            },
            ShiftFiscalized(key){
                const s = this.results[key]?.summary
                return s ? `Total fiscalized: ${s.fiscalized}` : null
            },
            FailedOrders(key){
                return this.results[key]?.summary?.failed_orders || []
            },
            
            VIEW_SHIFT(shift,dialog){
                this.selected_day_shift = shift
                this.dialog_shift_sales_report = !!dialog
            },

            //---------------[SYNC]------------
            CONFIRM_SYNC(keys,resubmit){
                try {
                    const count = this.MBS.actions.SIZE(keys)
                    this.MBS.actions.dialog({
                        show:true,
                        fixed:true,
                        icon:"mdi-cloud-sync-outline",
                        title:resubmit?"CONFIRM RESUBMITTING":"CONFIRM SYNCHING WITH EIS",
                        text:`Are you sure you want to ${resubmit?'resubmit':'synch'} ${count} day shift(s) with EIS?`,
                        action:{
                            code:PAGE_NAME+'=SYNC-EIS',
                            data:{keys,resubmit:!!resubmit},
                            all_users:true,
                            phone_number_start:true,
                            get_access:{
                                page_name:"home",
                            }
                        }
                    })
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'CONFIRM_SYNC',
                        page:PAGE_NAME,
                    })
                }
            },
            // keeps only what the UI needs (the full response has hundreds of success_orders per shift)
            SUMMARIZE(body){
                const errors = body?.eis_upload_errors || []
                const uploaded = toNumber(body?.eis_upload_success)
                const already = toNumber(body?.eis_upload_already)
                return {
                    orders:toNumber(body?.eis_upload_orders),
                    fiscalized:uploaded + already,
                    uploaded,
                    already,
                    failed:toNumber(body?.eis_upload_fail),
                    cancelled:toNumber(body?.eis_upload_skipped_cancelled),
                    partial:!!body?.isPartialProcessed || body?.success === false,
                    failed_orders:(body?.failed_orders || []).map(failed=>{
                        const order = errors.find(err=>String(err?.order?.key) == String(failed.key))?.order
                        return {
                            key:failed.key,
                            invoice_number:order?.eis_payload?.offline?.invoiceNumber || null,
                            till_code:order?.till_code || null,
                            total_price:order?.total_price || null,
                            message:failed.error_message || failed.error_code,
                        }
                    })
                }
            },
            async RUN_SYNC(keys,resubmit){
                try {
                    const company_key = this.SELECTED_COMPANY?.company_key || null
                    if (!resubmit) {
                        this.queue_keys = [...keys]
                    }
                    this.run_keys = [...keys]
                    this.expanded_key = null
                    this.stop_requested = false
                    this.syncing = true
                    this.step = 2
                    keys.forEach(key=>this.$set(this.results,key,{status:'pending'}))

                    for (const key of keys) {
                        if (this.stop_requested) {break}
                        const shift = this.FindShift(key)
                        // resubmit always posts, even when the dayshift is flagged as reconciled
                        // if (!resubmit && shift?.eis_reconciled) {
                        //     this.$set(this.results,key,{status:'already'})
                        //     continue
                        // }
                        this.current_key = key
                        this.$set(this.results,key,{status:'submitting'})
                        try {
                            const res = await this.MBS.actions.POST_REQUEST({
                                action:this.VALUE_ITEM,
                                path:"eis-reconcile-day-shift-sales",
                                app:"app2",
                                data:{
                                    company_key:company_key,
                                    production:DATA.EIS.production,
                                    day_shift_key:key
                                },
                                us:this.us
                            })
                            const summary = this.SUMMARIZE(res?.body)
                            const has_fail = summary.failed > 0 || summary.partial
                            this.$set(this.results,key,{status:has_fail?'partial':'success',summary})
                        } catch (error) {
                            console.log(error,'SYNC error...........',key)
                            const body = error?.error?.body
                            const message = body?.message || body?.error?.remark ||
                                (typeof body?.error == 'string'?body.error:null) ||
                                error?.message || "Request failed"
                            this.$set(this.results,key,{status:'error',message})
                        }
                    }

                    this.current_key = null
                    this.syncing = false
                    this.stop_requested = false
                    this.step = 3
                    this.MBS.events.$emit("SALES_AUDIT_SYNCED",{results:this.results})
                } catch (error) {
                    this.current_key = null
                    this.syncing = false
                    this.MBS.actions.error({
                        error:error,
                        from:'RUN_SYNC',
                        page:PAGE_NAME,
                    })
                }
            },

            DIALOG_YES(action){
                try {
                    if (action.code === PAGE_NAME+'=SYNC-EIS') {
                        if (action.YES) {
                            this.RUN_SYNC(action.data.keys,action.data.resubmit)
                        }
                    }
                } catch (error) {
                    this.MBS.actions.error({
                        error:error,
                        from:'DIALOG_YES',
                        page:PAGE_NAME,
                    })
                }
            },
        },
        beforeDestroy(){
            try {
                this.MBS.events.$off('DIALOG_YES', this.DIALOG_YES);
                this.MBS.events.$off('SALES_AUDIT_SYNC', this.OPEN_SALES_AUDIT_SYNC);
            } catch (error) {
                this.MBS.actions.error({
                    error:error,
                    from:'beforeDestroy',
                    page:PAGE_NAME,
                })
            }
        },
    }
</script>
